// Maps a DownlineCommission stake `code` (from /getdownlinecommission's
// `stakes` array) to a translation key, so the CommissionTable's dynamic
// column headers can be shown in the selected language instead of always
// rendering the API's Thai `name`. Falls back to the raw `name` for any
// code not listed here (e.g. a stake added on the backend before this map
// is updated), so nothing renders blank.
const STAKE_LABEL_KEYS = {
  first: "table_bet_first",
  four_top: "stake_label_four_top",
  four_tod: "stake_label_four_tod",
  three_top: "stake_label_three_top",
  three_front: "stake_label_three_front",
  three_bot: "stake_label_three_bot",
  three_tod: "stake_label_three_tod",
  two_top: "stake_label_two_top",
  two_bot: "stake_label_two_bot",
  run_top: "stake_label_run_top",
  run_bot: "stake_label_run_bot",
  run_top_front: "stake_label_run_top_front",
  run_top_mid: "stake_label_run_top_mid",
  run_top_end: "stake_label_run_top_end",
  run_bot_front: "stake_label_run_bot_front",
  run_bot_mid: "stake_label_run_bot_mid",
  run_bot_end: "stake_label_run_bot_end",
  run_top_big: "stake_label_run_top_big",
  run_top_small: "stake_label_run_top_small",
  run_top_even: "stake_label_run_top_even",
  run_top_odd: "stake_label_run_top_odd",
  run_bot_big: "stake_label_run_bot_big",
  run_bot_small: "stake_label_run_bot_small",
  run_bot_even: "stake_label_run_bot_even",
  run_bot_odd: "stake_label_run_bot_odd",
  run_top_front_even: "stake_label_run_top_front_even",
  run_top_front_odd: "stake_label_run_top_front_odd",
  run_top_front_small: "stake_label_run_top_front_small",
  run_top_front_big: "stake_label_run_top_front_big",
  run_top_mid_even: "stake_label_run_top_mid_even",
  run_top_mid_odd: "stake_label_run_top_mid_odd",
  run_top_mid_small: "stake_label_run_top_mid_small",
  run_top_mid_big: "stake_label_run_top_mid_big",
  run_top_end_even: "stake_label_run_top_end_even",
  run_top_end_odd: "stake_label_run_top_end_odd",
  run_top_end_small: "stake_label_run_top_end_small",
  run_top_end_big: "stake_label_run_top_end_big",
  run_bot_front_even: "stake_label_run_bot_front_even",
  run_bot_front_odd: "stake_label_run_bot_front_odd",
  run_bot_front_small: "stake_label_run_bot_front_small",
  run_bot_front_big: "stake_label_run_bot_front_big",
  run_bot_mid_even: "stake_label_run_bot_mid_even",
  run_bot_mid_odd: "stake_label_run_bot_mid_odd",
  run_bot_mid_small: "stake_label_run_bot_mid_small",
  run_bot_mid_big: "stake_label_run_bot_mid_big",
  run_bot_end_even: "stake_label_run_bot_end_even",
  run_bot_end_odd: "stake_label_run_bot_end_odd",
  run_bot_end_small: "stake_label_run_bot_end_small",
  run_bot_end_big: "stake_label_run_bot_end_big",
  step_front_mid_end: "stake_label_step_front_mid_end",
  step_mix: "stake_label_step_mix",
};

export const getStakeLabelKey = (code) => STAKE_LABEL_KEYS[code];

export const getStakeLabel = (stake, t) => {
  const key = getStakeLabelKey(stake.code);
  return key ? t(key) : stake.name;
};
